module.exports = __webpack_public_path__ + "018e7746c1249ab3b52b45b5ce42b667.svg";